import React from "react";
export const CheckBoxCellRenderer = (props) => React.createElement("input", { type: "checkbox", onChange: () => props.setValue && props.setValue(!props.value), checked: props.value ?? false });
